import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { log } from "console";
import { HomePageService } from "src/app/Services/home-page.service";
import { LoginUsersService } from "src/app/Services/login-users.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";

@Component({
    selector: "app-pdf-previewer",
    templateUrl: "./pdf-previewer.component.html",
    styleUrls: ["./pdf-previewer.component.scss"],
})
export class PdfPreviewerComponent implements OnInit {
    pdf_url: any;
    pdfSlug: any;
    loadingPdf = false;
    hide_header_footer = false;
    // public zoom = '50%';

    constructor(
        private route: ActivatedRoute,
        private staticPageService: StaticPagesService,
        private homePageService: HomePageService,
        private auth: LoginUsersService
    ) {}

    ngOnInit(): void {
        this.route.params.subscribe((params) => {
            this.pdfSlug = params.slug;
            if (
                window.location.href.includes("hide_header_footer=1") ||
                window.location.href.includes("/pdf/")
            ) {
                this.hide_header_footer = true;
            } else {
                this.hide_header_footer = false;
            }
            console.log("hide_header_footer => ", this.hide_header_footer);

            this.homePageService.getInitData().subscribe((res) => {
                if (res?.profile) {
                    this.auth.setToken(res?.profile.token);
                    this.getPdfData(this.pdfSlug);
                }
            });
        });
        // this.route.queryParams.subscribe((params: any) => {
        //     if (params?.link) {
        //         this.pdf_url = params?.link;
        //     }
        // });
    }
    getPdfData(pageSlug: any) {
        this.loadingPdf = true;
        this.staticPageService.getPdfUrl(pageSlug).subscribe((res) => {
            if (res?.data?.url) {
                this.pdf_url = res?.data?.url;
                this.loadingPdf = false;
            }
        });
    }
}
